var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEmp17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_5866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#F4C600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 34V20.6667L27.0563 14L36 20.6667V34H29.4187V26.0833H24.5531V34H18Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_5866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEmp17);
export default __webpack_public_path__ + "static/media/pin-emp-17.6c53aa52bb72ee719341cca1b76a06c9.svg";
export { ForwardRef as ReactComponent };